import { valuePropositions } from '@/mocks/features';

export default function ValueProposition() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left - Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20large%20monitor%20displaying%20colorful%20organized%20spreadsheet%20data%20charts%20and%20comparison%20tables%2C%20warm%20natural%20sunlight%20streaming%20through%20window%2C%20cream%20beige%20interior%20design%20with%20wooden%20desk%2C%20small%20potted%20plant%20and%20ceramic%20mug%2C%20serene%20productive%20atmosphere%2C%20editorial%20photography%20style%2C%20soft%20shadows%2C%20contemporary%20European%20home%20office%2C%20no%20people%20visible%2C%20warm%20neutral%20color%20palette%2C%20professional%20data%20analysis%20environment&width=800&height=600&seq=value-prop-v2-2026-x1&orientation=landscape"
                alt="ItaobuySpreadsheet product comparison workspace"
                title="ItaobuySpreadsheet - Organized Product Data Workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div className="w-full lg:w-1/2">
            <span className="inline-block px-3 py-1 text-xs font-semibold bg-accent-100 text-accent-700 rounded-full mb-4">
              Why Choose Us
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4 font-heading">
              Why ItaobuySpreadsheet?
            </h2>
            <p className="text-sm text-foreground-600 mb-6 leading-relaxed">
              The <strong>itaobuyspreadsheet</strong> is not just a list — it is a structured product intelligence system that helps shoppers, resellers, and product researchers make data-driven decisions.
            </p>
            <ul className="space-y-3">
              {valuePropositions.map((vp, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs text-accent-600"></i>
                  </div>
                  <span className="text-sm text-foreground-700">{vp}</span>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-sm text-foreground-500 italic">
              Built for shoppers, resellers, and product researchers who want clarity in a crowded marketplace.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}